import React, { Suspense } from 'react'
import classes from './DeployButton.module.scss'
import Button from '@/components/ui/Buttons/Button'
import { useGetProject, useGetRoute } from '@/lib/react-query'
import { Popper } from '@/components/ui/Popper'
import { usePopper } from '@/components/ui/Popper/Popper.hooks'
import HttpDeployInstructions from './HttpDeployInstructions'
import MailDeployInstructions from '@/components/DeployButton/MailDeployInstructions'
import CronDeployInstructions from '@/components/DeployButton/CronDeployInstructions'
import { isZendeskApp } from '@/features/zendesk-app'
import { TabPanel, Tabs } from '@mui/base'
import { TabsList } from '@/components/ui/TabsList'
import { Tab } from '@/components/ui/Tab'
import ZendeskAppDeployInstructions from '@/components/DeployButton/ZendeskAppDeployInstructions'
import { ClickAwayListener } from '@mui/base/ClickAwayListener'
import FlowDeployInstructions from '@/components/DeployButton/FlowDeployInstructions'

export type DeployButtonProps = {
  projectId: number
  routeId: number
}

export const DeployButton = ({ projectId, routeId }: DeployButtonProps) => {
  const { id, toggle, setAnchorEl, popperProps } = usePopper('how-to-deploy')
  const {
    data: { route },
  } = useGetRoute(projectId, routeId)
  useGetProject(projectId) // Preload project for instructions

  return (
    <div>
      <Button variant={'outlined'} color={'neutral'} aria-describedby={id} onClick={toggle}>
        {route.type === 'cron' && 'Schedule'}
        {route.type === 'flow' && 'How to use?'}
        {!['cron', 'flow'].includes(route.type!) && 'How to deploy ?'}
      </Button>
      <Suspense fallback={''}>
        <Popper {...popperProps}>
          <ClickAwayListener onClickAway={() => setAnchorEl(null)} disableReactTree>
            <div className={classes.root}>
              {(route.type === 'httpV1' || route.type === 'httpV2') && (
                <>
                  <Tabs defaultValue={isZendeskApp() ? 'zendesk' : 'http'}>
                    {isZendeskApp() && (
                      <TabsList>
                        <Tab value={'zendesk'}>Zendesk</Tab>
                        <Tab value={'http'}>Other</Tab>
                      </TabsList>
                    )}

                    <TabPanel value={'zendesk'}>
                      <ZendeskAppDeployInstructions projectId={projectId} routeId={routeId} />
                    </TabPanel>
                    <TabPanel value={'http'}>
                      <HttpDeployInstructions projectId={projectId} routeId={routeId} />
                    </TabPanel>
                  </Tabs>
                </>
              )}
              {route.type === 'mail' && <MailDeployInstructions projectId={projectId} routeId={routeId} />}
              {route.type === 'cron' && <CronDeployInstructions projectId={projectId} routeId={routeId} />}
              {route.type === 'flow' && <FlowDeployInstructions projectId={projectId} routeId={routeId} />}
            </div>
          </ClickAwayListener>
        </Popper>
      </Suspense>
    </div>
  )
}
